"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2042],{

/***/ 32042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ SignUpFormField; },
/* harmony export */   "h": function() { return /* binding */ createContactInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12601);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20368);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77480);
/* harmony import */ var hooks_useValidation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70750);
/* harmony import */ var ui_components_AddressLookup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39309);
/* harmony import */ var ui_forms_custom_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21541);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79758);
/* harmony import */ var utils_matchStateAndPostalCode__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44321);
/* harmony import */ var utils_richTranslate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80198);
/* harmony import */ var utils_dateFormatter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41676);















var SIXTEEN_YEARS = 60 * 60 * 24 * 365 * 16 * 1000;
var SignUpFormField = function(param) {
    var field = param.field, form = param.form, isLoading = param.isLoading, inverted = param.inverted, details = param.details;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_4__/* .useTranslate */ .qM)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,hooks_useValidation__WEBPACK_IMPORTED_MODULE_5__/* .useValidation */ .V)(), 1), validate = ref[0];
    var ref1 = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_3__/* .useSiteConfig */ .N)(), countryCode = ref1.countryCode, googleApiKey = ref1.env.googleApiKey, newsletter = ref1.newsletter;
    switch(field){
        case "address":
            var ref2;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_components_AddressLookup__WEBPACK_IMPORTED_MODULE_6__/* .AddressLookup */ .Ij, {
                invert: inverted,
                name: "addressLine",
                defaultValue: form.watch("addressLine"),
                id: "address-line",
                "data-test-id": "sign-up-address-lookup",
                label: t("address1"),
                placeholder: t("address1"),
                lookupConstraints: utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .SHIPPING_LOOKUP_CONSTRAINTS */ .mV[countryCode],
                onSelect: function(param) {
                    var postalCode = param.postalCode, address1 = param.address1, city = param.city;
                    if (postalCode && address1 && city) {
                        form.setValue("addressCity", city);
                        form.setValue("addressPostalCode", postalCode);
                        form.setValue("addressLine", address1);
                    }
                },
                ref: form.register({
                    required: t("requiredField"),
                    maxLength: {
                        value: 50,
                        message: t("genericFieldMaxLength", {
                            length: 50
                        })
                    }
                }),
                maxLength: 50,
                required: true,
                errorText: (ref2 = form.errors.addressLine) === null || ref2 === void 0 ? void 0 : ref2.message,
                disabled: isLoading
            });
        case "city":
            var ref3;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oHY, {
                invert: inverted,
                id: "addressCity",
                name: "addressCity",
                label: t("city"),
                placeholder: t("city"),
                ref: form.register({
                    validate: validate.safeInput,
                    required: t("requiredField"),
                    minLength: {
                        value: 2,
                        message: t("genericFieldMinLength", {
                            length: 2
                        })
                    },
                    maxLength: {
                        value: 50,
                        message: t("genericFieldMaxLength", {
                            length: 50
                        })
                    }
                }),
                disabled: isLoading,
                minLength: 2,
                maxLength: 50,
                errorText: (ref3 = form.errors.addressCity) === null || ref3 === void 0 ? void 0 : ref3.message,
                required: true,
                crossOrigin: undefined
            });
        case "zip-code":
            var ref4;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oHY, {
                invert: inverted,
                id: "addressPostalCode",
                name: "addressPostalCode",
                label: t("postalCode"),
                placeholder: t("postalCode"),
                ref: form.register({
                    required: t("requiredField"),
                    minLength: {
                        value: 5,
                        message: t("genericFieldMinLength", {
                            length: 5
                        })
                    },
                    maxLength: {
                        value: 10,
                        message: t("genericFieldMaxLength", {
                            length: 10
                        })
                    },
                    validate: function(value) {
                        if (!value) return;
                        var errorMessage = validate.postalCode(value);
                        return errorMessage;
                    }
                }),
                disabled: isLoading,
                minLength: 5,
                maxLength: 10,
                errorText: (ref4 = form.errors.addressPostalCode) === null || ref4 === void 0 ? void 0 : ref4.message,
                required: true,
                crossOrigin: undefined
            });
        case "email":
            var ref5;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oHY, {
                id: "email",
                invert: inverted,
                className: "w-full",
                name: "email",
                type: "email",
                label: t("email"),
                placeholder: t("email"),
                disabled: isLoading,
                required: true,
                ref: form.register({
                    required: t("requiredField"),
                    validate: validate.email,
                    maxLength: {
                        value: 50,
                        message: t("yourEmailCannotBeLong", {
                            length: 50
                        })
                    }
                }),
                maxLength: 50,
                errorText: (ref5 = form.errors.email) === null || ref5 === void 0 ? void 0 : ref5.message,
                crossOrigin: undefined
            });
        case "dob":
            var ref6;
            var validateDob = function(value) {
                var invalidDOB = validate.dateOfBirth(value);
                if (invalidDOB) return invalidDOB;
                var currentTimeStamp = new Date().getTime();
                var birthdateTimestamp = (0,utils_dateFormatter__WEBPACK_IMPORTED_MODULE_12__/* .getDateFromCountryFormat */ .Ig)(value, countryCode).getTime();
                if (isNaN(birthdateTimestamp)) {
                    return t("newsletterPopoverDobInvalid");
                }
                var targetTimeStamp = currentTimeStamp - SIXTEEN_YEARS;
                if (birthdateTimestamp > targetTimeStamp) {
                    return t("newsletterPopoverAgeRestriction");
                }
                return undefined;
            };
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oHY, {
                id: "dob",
                name: "dob",
                invert: inverted,
                label: t("newsletterPopoverDOBPlaceholder"),
                placeholder: t("newsletterPopoverDOBPlaceholder"),
                maxLength: 10,
                disabled: isLoading,
                required: true,
                ref: form.register({
                    required: t("newsletterPopoverDobRequired"),
                    validate: validateDob
                }),
                errorText: (ref6 = form.errors.dob) === null || ref6 === void 0 ? void 0 : ref6.message,
                crossOrigin: undefined
            });
        case "interests":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputSelect */ .JDu, {
                invert: inverted,
                disabled: isLoading,
                name: "shoppingPreference",
                options: [
                    {
                        label: t("newsletterMens"),
                        value: "mens"
                    },
                    {
                        label: t("newsletterWomens"),
                        value: "womens"
                    },
                    {
                        label: t("newsletterKids"),
                        value: "kids"
                    },
                    {
                        label: t("newsletterAll"),
                        value: "all"
                    }, 
                ],
                placeholder: t("newsletterPopoverChoosePreference"),
                defaultValue: form.watch("shoppingPreference"),
                id: "shoppingPreference",
                dataTestId: "sign-up-interests",
                label: t("newsletterPopoverShoppingPreference"),
                ref: form.register({
                    required: t("newsletterPopoverShoppingPreferenceError")
                }),
                errorText: form.errors.shoppingPreference && form.errors.shoppingPreference.message
            });
        case "phone":
            var ref7;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oHY, {
                invert: inverted,
                disabled: isLoading,
                ref: form.register({
                    required: t("requiredField"),
                    validate: validate.phoneNumber,
                    maxLength: {
                        value: 30,
                        message: t("genericFieldMaxLength", {
                            length: 30
                        })
                    }
                }),
                name: "phoneNumber",
                id: "phone-number",
                type: "tel",
                errorText: (ref7 = form.errors.phoneNumber) === null || ref7 === void 0 ? void 0 : ref7.message,
                maxLength: 30,
                label: t("phone"),
                placeholder: t("phone"),
                required: true,
                crossOrigin: undefined
            });
        case "firstName":
        case "lastName":
            var ref8;
            var ref9 = field === "firstName" ? {
                id: "first-name",
                placeholder: t(field)
            } : {
                id: "last-name",
                placeholder: t(field)
            }, id = ref9.id, placeholder = ref9.placeholder;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oHY, {
                invert: inverted,
                disabled: isLoading,
                ref: form.register({
                    required: t("requiredField"),
                    validate: validate.safeInput
                }),
                name: field,
                id: id,
                label: placeholder,
                placeholder: placeholder,
                errorText: (ref8 = form.errors[field]) === null || ref8 === void 0 ? void 0 : ref8.message,
                required: true,
                crossOrigin: undefined
            });
        case "opt-out":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputCheckbox */ .o2J, {
                invert: inverted,
                ref: form.register({
                    required: t("requiredField")
                }),
                name: field,
                id: field,
                readOnly: true,
                children: field.toUpperCase()
            });
        case "ageCheck":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputCheckbox */ .o2J, {
                invert: inverted,
                ref: form.register({
                    required: t("requiredField")
                }),
                name: field,
                id: field,
                required: true,
                children: t("legalAgeCheck")
            });
        case "montreal":
        case "toronto":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputCheckbox */ .o2J, {
                invert: inverted,
                ref: form.register({
                    validate: function() {
                        return form.watch("toronto") || form.watch("montreal") || "Select at least one city";
                    }
                }),
                name: field,
                id: field,
                children: field.toUpperCase()
            });
        case "california":
            var ref10;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputSelect */ .JDu, {
                invert: inverted,
                id: "address-form-state-select",
                dataTestId: "address-form-state-select-california",
                label: t("state"),
                placeholder: t("selectState"),
                defaultValue: "CA",
                options: [
                    {
                        label: "California",
                        value: "CA"
                    }
                ],
                className: "pt-0.5 pb-1",
                name: "stateCode",
                required: true,
                ref: form.register({
                    required: t("requiredField"),
                    validate: {
                        postalStateMatch: function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(value) {
                                var postalCode, isMatch, _tmp;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (value !== "CA") return [
                                                2,
                                                "California residents only"
                                            ];
                                            postalCode = form.getValues("addressPostalCode");
                                            if (!postalCode || form.errors.addressPostalCode) return [
                                                2,
                                                undefined
                                            ];
                                            _tmp = {};
                                            return [
                                                4,
                                                (0,utils_matchStateAndPostalCode__WEBPACK_IMPORTED_MODULE_9__/* .matchStateAndPostalCode */ .J)((_tmp.postalCode = postalCode, _tmp.stateCode = value ? value : null, _tmp.country = "US", _tmp.googleApiKey = googleApiKey, _tmp))
                                            ];
                                        case 1:
                                            isMatch = _state.sent().isMatch;
                                            if (!isMatch) return [
                                                2,
                                                t("stateInvalidPostcode")
                                            ];
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(value) {
                                return _ref.apply(this, arguments);
                            };
                        }()
                    }
                }),
                errorText: (ref10 = form.errors.stateCode) === null || ref10 === void 0 ? void 0 : ref10.message
            });
        case "gender":
            var ref11, ref12, ref13, ref14;
            var genderValues = (newsletter === null || newsletter === void 0 ? void 0 : (ref11 = newsletter.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.gender) === null || ref12 === void 0 ? void 0 : ref12.values) || [
                "male",
                "female",
                "noAnswer", 
            ];
            var genderRequired = newsletter === null || newsletter === void 0 ? void 0 : (ref13 = newsletter.fields) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.gender) === null || ref14 === void 0 ? void 0 : ref14.required;
            var genderSelectItems = genderValues.map(function(value) {
                return {
                    value: value,
                    label: value
                };
            });
            var genderFieldsTranslated = genderSelectItems ? (0,ui_forms_custom_helpers__WEBPACK_IMPORTED_MODULE_7__/* .translateSelectOptions */ .cE)(genderSelectItems, t) : [];
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputSelect */ .JDu, {
                invert: inverted,
                dataTestId: "sign-up-gender-select",
                disabled: isLoading,
                name: "gender",
                options: genderFieldsTranslated,
                placeholder: t("gender"),
                id: "gender",
                label: t("newsletterChoseGender"),
                ref: form.register({
                    required: t("requiredField")
                }),
                required: genderRequired,
                errorText: form.errors.gender && form.errors.gender.message
            });
        case "emailPreference":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-start text-left",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputCheckbox */ .o2J, {
                    name: field,
                    id: field,
                    invert: inverted,
                    ref: form.register(),
                    children: t("newsletterPopoverBeTheFirst")
                })
            });
        case "sms-opt-in":
            var ref15;
            var smsOptInValue = form.watch("smsOptIn");
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputText */ .oHY, {
                        invert: inverted,
                        disabled: isLoading,
                        optional: true,
                        ref: form.register({
                            validate: {
                                phoneNumber: function(value) {
                                    return !value || validate.phoneNumber(value);
                                },
                                smsOptIn: function(phoneNumber) {
                                    var smsOptIn = form.getValues().smsOptIn;
                                    // The checkbox and phone number must be submitted together, or not at all:
                                    if (phoneNumber && !smsOptIn) {
                                        return t("smsOptInMustBeChecked");
                                    }
                                    if (!phoneNumber && smsOptIn) {
                                        return t("requiredField");
                                    }
                                    return true;
                                }
                            },
                            maxLength: {
                                value: 30,
                                message: t("genericFieldMaxLength", {
                                    length: 30
                                })
                            }
                        }),
                        name: "phoneNumber",
                        id: "phone-number",
                        type: "tel",
                        errorText: (ref15 = form.errors.phoneNumber) === null || ref15 === void 0 ? void 0 : ref15.message,
                        maxLength: 30,
                        label: t("smsOptInPhoneNumberLabel"),
                        placeholder: t("smsOptInPhoneNumberLabel"),
                        crossOrigin: undefined
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .InputCheckbox */ .o2J, {
                        className: "mt-4",
                        name: "smsOptIn",
                        id: "smsOptIn",
                        invert: inverted,
                        ref: form.register({
                            validate: {
                                fields: function(smsOptIn) {
                                    var ref = form.getValues(), email = ref.email, firstName = ref.firstName, lastName = ref.lastName, phoneNumber = ref.phoneNumber;
                                    if (firstName === "" && smsOptIn) {
                                        form.setError("firstName", {
                                            type: "required",
                                            message: t("requiredField")
                                        });
                                    }
                                    if (lastName === "" && smsOptIn) {
                                        form.setError("lastName", {
                                            type: "required",
                                            message: t("requiredField")
                                        });
                                    }
                                    if (email === "" && smsOptIn) {
                                        form.setError("email", {
                                            type: "required",
                                            message: t("requiredField")
                                        });
                                    }
                                    if (phoneNumber === "" && smsOptIn) {
                                        form.setError("phoneNumber", {
                                            type: "required",
                                            message: t("requiredField")
                                        });
                                    }
                                    return true;
                                }
                            }
                        }),
                        onChange: function() {
                            var ref, ref1, ref2, ref3, ref4;
                            // Clear the error if the checkbox is selected and the error message matches the expected error.
                            // Note: The `deps` register option would be a better way to do this, but it's not available in v6.
                            if (((ref = form.errors.phoneNumber) === null || ref === void 0 ? void 0 : ref.message) === t("smsOptInMustBeChecked")) {
                                form.clearErrors("phoneNumber");
                            }
                            if (((ref1 = form.errors.firstName) === null || ref1 === void 0 ? void 0 : ref1.message) === t("requiredField")) {
                                form.clearErrors("firstName");
                            }
                            if (((ref2 = form.errors.lastName) === null || ref2 === void 0 ? void 0 : ref2.message) === t("requiredField")) {
                                form.clearErrors("lastName");
                            }
                            if (((ref3 = form.errors.email) === null || ref3 === void 0 ? void 0 : ref3.message) === t("requiredField")) {
                                form.clearErrors("email");
                            }
                            if (((ref4 = form.errors.phoneNumber) === null || ref4 === void 0 ? void 0 : ref4.message) === t("requiredField")) {
                                form.clearErrors("phoneNumber");
                            }
                            form.trigger();
                        },
                        children: t("smsOptInLabel")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: smsOptInValue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                    size: "xs",
                                    className: "block mt-4",
                                    children: t("smsOptInTermsAndConditions", {
                                        ctaLabel: details.ctaLabel
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                                    size: "xs",
                                    className: "block",
                                    children: (0,utils_richTranslate__WEBPACK_IMPORTED_MODULE_10__/* .richTranslate */ .Q)(t, "smsOptInTermsAndConditionsView", {
                                        termsLink: function(text) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .LinkText */ .u66, {
                                                label: text,
                                                target: "_blank",
                                                href: "/help/terms-and-conditions"
                                            });
                                        },
                                        privacyLink: function(text) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .LinkText */ .u66, {
                                                label: text,
                                                target: "_blank",
                                                href: "/help/privacy-policy"
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    })
                ]
            });
        default:
            return null;
    }
};
var createContactInput = function(data, contactSource, countryCode) {
    var contact = {
        email: data.email,
        emailPreference: "optIn",
        contactSource: contactSource
    };
    if (data.emailPreference !== undefined) {
        contact.emailPreference = data.emailPreference ? "optIn" : "optOut";
    }
    if (data.dob) {
        var date = (0,utils_dateFormatter__WEBPACK_IMPORTED_MODULE_12__/* .getDateFromCountryFormat */ .Ig)(data.dob, countryCode);
        contact.dob = {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        };
    }
    if (data.firstName && data.lastName) {
        contact.firstName = data.firstName;
        contact.lastName = data.lastName;
    }
    if (data.gender) {
        contact.gender = data.gender;
    }
    if (data.shoppingPreference) {
        contact.shoppingPreference = data.shoppingPreference;
    }
    if (data.phoneNumber) {
        contact.phoneNumber = data.phoneNumber;
    }
    if (data.addressLine && data.addressCity && data.addressPostalCode) {
        contact.address = data.addressLine;
        contact.postalCode = data.addressPostalCode;
        contact.city = data.addressCity;
    }
    if (data.toronto) {
        contact.toronto = true;
    }
    if (data.montreal) {
        contact.montreal = true;
    }
    if (data.smsOptIn !== undefined) {
        contact.smsOptIn = data.smsOptIn;
    }
    return contact;
};


/***/ }),

/***/ 41676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ig": function() { return /* binding */ getDateFromCountryFormat; },
/* harmony export */   "gH": function() { return /* binding */ dateToShortForm; },
/* harmony export */   "sG": function() { return /* binding */ parseDate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5341);

var SHORT_FORM_MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec", 
];
var dateToShortForm = function(dt) {
    return "".concat(dt.getDate(), " ").concat(SHORT_FORM_MONTHS[dt.getMonth()]);
};
/**
 * Parses a date string and returns an object containing its components.
 *
 * @example
 * const date = '2021-04-01T06:30:00.000Z';
 * console.log(parseDate(date));
 * // {
 * //   year: 2021,
 * //   month: 3,
 * //   longMonth: 'april',
 * //   day: 1,
 * //   weekDay: 4,
 * // }
 */ var parseDate = function(dateString) {
    var date = new Date(dateString);
    return {
        year: date.getFullYear(),
        month: date.getMonth(),
        longMonth: date// We hardcode the locale to 'en-GB' because we need the month to be in English
        .toLocaleString("en-GB", {
            month: "long"
        }).toLowerCase(),
        day: date.getDate(),
        weekDay: date.getDay()
    };
};
var getDateFromCountryFormat = function(dateString, countryCode) {
    switch(countryCode){
        case "gb":
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(dateString.split("/"), 3), day = ref[0], month = ref[1], year = ref[2];
            return new Date(+year, +month - 1, +day);
        default:
            return new Date(dateString);
    }
};


/***/ }),

/***/ 80198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ richTranslate; }
/* harmony export */ });
/* unused harmony export executeTemplate */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3204);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);



/**
 * Translates text, allowing the injection of JSX elements.
 *
 * @example
 * With a template like:
 *   viewTermsAndPrivacy: 'View {termsLink("Terms")} and {privacyLink("Privacy")}.'
 * You can execute this template via:
 *   richTranslate(t, 'viewTermsAndPrivacy', {
 *     termsLink: (text) => <LinkText href="/terms" label={text} />,
 *     privacyLink: (text) => <LinkText href="/privacy" label={text} />,
 *   });
 *
 * @param t - The translate function that comes from the `useTranslate` hook
 * @param translationKey - The translation key, which should contain a translation template
 * @param variables - The variables to inject into the translation template
 */ function richTranslate(t, translationKey, variables) {
    var translated = t(translationKey);
    return executeTemplate(translated, variables);
}
function executeTemplate(template, variables) {
    var execute = parseTemplate(template);
    return execute(variables);
}
/**
 * Parses the template into an executable function
 */ function parseTemplate(text) {
    var segments = [];
    // Finds all {expressions} in the template
    var templatePattern = /\{([^}]+)}/g;
    // Build the template results:
    var m;
    var lastIndex = 0;
    while(m = templatePattern.exec(text)){
        // Add literal text:
        if (lastIndex < m.index) {
            var literalText = text.substring(lastIndex, m.index);
            segments.push(literalText);
        }
        // Add the result of the expression:
        var expression = m[1];
        segments.push(parseExpression(expression));
        lastIndex = templatePattern.lastIndex;
    }
    // Grab the final literal text:
    if (lastIndex !== text.length) {
        segments.push(text.substring(lastIndex, text.length));
    }
    return function executeTemplate(variables) {
        var /*#__PURE__*/ _React;
        var children = segments.map(function(seg) {
            return typeof seg === "function" ? seg(variables) : seg;
        });
        return (_React = react__WEBPACK_IMPORTED_MODULE_0__).createElement.apply(_React, [
            react__WEBPACK_IMPORTED_MODULE_0__.Fragment,
            null
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(children)));
    };
}
/**
 * Parses an expression into an executable function.
 * An expression is the text inside the {template} tags.
 *
 * This function is extremely basic, it only supports:
 * - A simple key, eg. {key}
 * - A function call, eg. {key()}
 * - A function call with primitive args, eg. {key("Text")}
 */ function parseExpression(expression) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(expression.match(/^(.+?)(?:[(](.*)[)])?$/), 3), _ = ref[0], key = ref[1], args = ref[2];
    // Args can only be JSON values, usually strings:
    var parsedArgs = args ? JSON.parse("[".concat(args, "]")) : [];
    return function executeExpression(variables) {
        var value = variables[key];
        if (typeof value === "function") {
            value = value.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(parsedArgs));
        }
        return value;
    };
}


/***/ })

}]);